import React from 'react'
import { Row, Col } from 'react-bootstrap'
import classnames from 'classnames'
import styles from './styles'

const Home = () => {
  return (<>
    <Row className={styles.heading_wrapper}>
      <Col>
        <div className={classnames(styles.box_1, styles.boxes)} />
      </Col>
      <Col>
        <a href='/football-development'>
          <div className={classnames(styles.box_2, styles.boxes)}>
            <div className={styles.overlay}>
              <h2 className='text-white'>Football Development</h2>
              <p className={styles.small_text}>Ensuring the future of the game by optimising the elite development and personal growth of the people involved in it, fulfilling our duty of care for those individuals and embedding continuous improvement and rigorous quality assurance.</p>
            </div>
          </div>
        </a>
      </Col>
      <Col>
        <a href='/football-operations'>
          <div className={classnames(styles.box_3, styles.boxes)}>
            <div className={styles.overlay}>
              <h2 className='text-white'>Football Operations</h2>
              <p className={styles.small_text}>Delivering and administering 380 Premier League matches, including Match Centre, playing strips, match delegates and relationships with PGMOL and Hawk-Eye.</p>
            </div>
          </div>
        </a>
      </Col>
      <Col>
        <a href='/football-administration'>
          <div className={classnames(styles.box_4, styles.boxes)}>
            <div className={styles.overlay}>
              <h2 className='text-white'>Football Administration</h2>
              <p className={styles.small_text}>Managing all player and staff registrations, administering compensation, calendar matters, and Premier League fixtures throughout the season.</p>
            </div>
          </div>
        </a>
      </Col>
    </Row>
    <Row className={styles.content_wrapper}>
      <Col>
        <h1 className={classnames(styles.text_color, styles.heading_text)}>The Best Football.</h1>
      </Col>
      <Col className='align-self-center'>
        <Row className='mb-2'>
          <h3 className={classnames(styles.text_color, 'text-end')}>The Football Department.</h3>
        </Row>
        <Row>
          <p className={classnames(styles.text_color, 'text-end')}>Maintaining and enhancing our position as the<br /> best football competition in the world</p>
        </Row>
      </Col>
    </Row>
  </>
  )
}

export default Home
